import React, { useContext, useState } from "react";
import { CheckCircle, Cancel } from "@mui/icons-material";
import TableComponent from "../TableComponent/TableComponent";
import { useQuery } from "react-query";
import { QK } from "../../base/qk";
import { getScheduleJobByStatus } from "../../api/services/scheduling";
import HouseKeepingConfirmModal from "./modals/HouseKeepingConfirmModal";
import { Button } from "@mui/material";
import CancelJobModal from "./modals/CancelJobModal";
import MyContext from "../../context/MyContext";
import Loader from "../Loader/Loader";
import NotFound from "../NotFound/NotFound";
import { formatDateTimeRange } from "../../base/FormatTime";

const JobsNotStarted = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedJob, setSelectedJob] = useState(null);
  const [showJobModal, setShowJobModal] = useState(false);
  const [showCancelJobModal, setShowCancelJobModal] = useState(false);
  const { locationID } = useContext(MyContext);
  const jobPerPage = 10;

  const { data: notStartedJobs, isLoading } = useQuery(
    [QK.notStartedJobs, currentPage, locationID],
    () => getScheduleJobByStatus(currentPage, 1, locationID),
    { keepPreviousData: true, enabled: !!currentPage || !!locationID }
  );

  const totalRecords = notStartedJobs?.count || 0;
  const totalPages = Math.ceil(totalRecords / jobPerPage);

  const handlePageChange = (event, page) => setCurrentPage(page);

  const handleShowJobModal = (jobId) => {
    setSelectedJob(jobId);
    setShowJobModal(true);
  };

  const handleShowCancelJobModal = (jobId) => {
    setSelectedJob(jobId);
    setShowCancelJobModal(true);
  };

  const columns = [
    {
      field: "startDateTime",
      headerName: "Scheduled Start Date Time",
    },
    {
      field: "jobName",
      headerName: "Job Name",
    },
    {
      field: "serviceUser",
      headerName: "Service User",
    },
    {
      field: "employee",
      headerName: "Employee(s)",
    },
  ];

  const data =
    notStartedJobs?.results?.map((job) => ({
      id: job.id,
      startDateTime: formatDateTimeRange(
        job.scheduled_start,
        job.scheduled_end
      ),
      jobName: job.visit_name,
      serviceUser: job.client_name,
      employee:
        job.assigned_employee_details.length > 0
          ? job.assigned_employee_details
              .map((emp) => `${emp.first_name} ${emp.last_name}`)
              .join(", ")
          : "—",
    })) || [];

  const actions = [
    {
      element: (row) => (
        <Button
          startIcon={<Cancel />}
          color="error"
          onClick={() => handleShowCancelJobModal(row.id)}
          variant="outlined"
          size="small"
        >
          Cancel Job
        </Button>
      ),
    },
    {
      element: (row) => (
        <Button
          startIcon={<CheckCircle />}
          color="primary"
          onClick={() => handleShowJobModal(row.id)}
          variant="outlined"
          size="small"
          className="ml-2"
        >
          Complete Job
        </Button>
      ),
    },
  ];
  if (isLoading) return <Loader />;
  if (data?.length === 0) return <NotFound message="No jobs found" />;

  return (
    <div style={{ padding: "20px" }}>
      <TableComponent
        columns={columns}
        data={data}
        actions={actions}
        isLoading={isLoading}
        pagination={{ totalPages, currentPage }}
        onPageChange={handlePageChange}
      />
      {/* Job Details Modal */}
      {showJobModal && (
        <HouseKeepingConfirmModal
          jobId={selectedJob}
          open={showJobModal}
          handleClose={() => setShowJobModal(false)}
        />
      )}
      {showCancelJobModal && (
        <CancelJobModal
          open={showCancelJobModal}
          jobId={selectedJob}
          handleClose={() => setShowCancelJobModal(false)}
        />
      )}
    </div>
  );
};

export default JobsNotStarted;
